(() => {
  const drawer = () => document.querySelector('cart-drawer');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Capa de carga dentro del carrito
  function ensureLoader() {
    const d = drawer();
    const inner = d && d.querySelector('.drawer__inner');
    if (!inner || inner.querySelector('.titan-loader')) return;
    const el = document.createElement('div');
    el.className = 'titan-loader';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="titan-cube"><span></span><span></span><span></span><span></span><span></span><span></span></div><div>Agregando al carrito…</div>';
    inner.appendChild(el);
  }

  function addShine() {
    const btn = document.getElementById('CartDrawer-Checkout');
    if (btn && !btn.querySelector('.titan-shine')) {
      const s = document.createElement('span');
      s.className = 'titan-shine';
      btn.appendChild(s);
    }
  }

  const STORAGE_VARIANT_ID = 50519870243051;
  const STORAGE_IMAGE = 'https://cdn.shopify.com/s/files/1/0842/7782/1675/files/BadgeFruitStorage_800x800.webp?v=1790222182';

  function storageAlreadyInCart(d) {
    return !!d.querySelector('[data-quantity-variant-id="' + STORAGE_VARIANT_ID + '"], a[href*="/products/fruit-storage-1"]');
  }

  function readRobloxUser(d) {
    const match = (d.innerText || '').match(/Usuario exacto de Roblox:\s*([^\n\r]+)/i);
    return match ? match[1].trim() : '';
  }

  function ensureStorageUpsell() {
    const d = drawer();
    const footer = d && d.querySelector('.drawer__footer');
    if (!footer) return;

    let card = d.querySelector('.titan-storage-upsell');
    if (!d.querySelector('.cart-item')) {
      if (card) card.remove();
      return;
    }
    if (storageAlreadyInCart(d)) {
      if (card) card.remove();
      return;
    }
    if (card) return;

    card = document.createElement('section');
    card.className = 'titan-storage-upsell';
    card.setAttribute('aria-label', 'Agregar Fruit Storage +1');
    card.innerHTML =
      '<img class="titan-storage-upsell__image" src="' + STORAGE_IMAGE + '" alt="Fruit Storage +1">' +
      '<div class="titan-storage-upsell__body">' +
        '<span class="titan-storage-upsell__eyebrow">MEJORA TU INVENTARIO</span>' +
        '<strong>¿No te gustaría un +1 Storage?</strong>' +
        '<p>Guarda una fruta permanente más y evita quedarte sin espacio.</p>' +
        '<div class="titan-storage-upsell__actions">' +
          '<input class="titan-storage-upsell__user" type="text" maxlength="40" autocomplete="off" placeholder="Usuario exacto de Roblox" aria-label="Usuario exacto de Roblox para Fruit Storage">' +
          '<button class="titan-storage-upsell__add" type="button">Agregar por $119</button>' +
        '</div>' +
        '<small class="titan-storage-upsell__status" aria-live="polite"></small>' +
      '</div>';

    footer.insertBefore(card, footer.firstChild);
    const input = card.querySelector('.titan-storage-upsell__user');
    const button = card.querySelector('.titan-storage-upsell__add');
    const status = card.querySelector('.titan-storage-upsell__status');
    const savedUser = readRobloxUser(d);
    if (savedUser) input.value = savedUser;

    button.addEventListener('click', async () => {
      const robloxUser = input.value.trim();
      input.classList.remove('titan-storage-upsell__user--error');
      status.textContent = '';
      if (!robloxUser) {
        input.classList.add('titan-storage-upsell__user--error');
        status.textContent = 'Escribe tu usuario exacto de Roblox.';
        input.focus();
        return;
      }

      button.disabled = true;
      button.textContent = 'Agregando…';
      try {
        const sectionIds = typeof d.getSectionsToRender === 'function'
          ? d.getSectionsToRender().map((section) => section.id)
          : [];
        const body = {
          items: [{
            id: STORAGE_VARIANT_ID,
            quantity: 1,
            properties: {
              'Usuario exacto de Roblox': robloxUser,
              'Artículo seleccionado': 'Fruit Storage +1',
              'Método de entrega': 'Gifting manual'
            }
          }]
        };
        if (sectionIds.length) {
          body.sections = sectionIds;
          body.sections_url = window.location.pathname;
        }
        const response = await fetch((window.routes && routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'No se pudo agregar');
        if (result.sections && typeof d.renderContents === 'function') {
          d.renderContents(result);
          d.open();
        } else {
          window.location.reload();
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'titan-storage-upsell', productVariantId: STORAGE_VARIANT_ID });
        }
      } catch (error) {
        button.disabled = false;
        button.textContent = 'Agregar por $119';
        status.textContent = error && error.message ? error.message : 'Inténtalo de nuevo.';
      }
    });
  }

  let loadingTimer = null;
  function stopLoading() {
    const d = drawer();
    if (d) d.classList.remove('titan-loading');
    clearTimeout(loadingTimer);
  }

  // 1) Abrir el carrito al instante al dar "Agregar al carrito"
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    const pf = form.closest('product-form');
    const btn = pf && pf.querySelector('[type="submit"]');
    if (!pf || (btn && btn.getAttribute('aria-disabled') === 'true')) return;
    const d = drawer();
    if (!d) return;
    if (form.closest('quick-add-modal')) return; // el modal se cierra primero
    ensureLoader();
    let before = null;
    fetch('/cart.js').then((r) => r.json()).then((c) => (before = c.item_count)).catch(() => {});
    d.classList.add('titan-loading');
    d.open(btn);
    clearTimeout(loadingTimer);
    loadingTimer = setTimeout(async () => {
      stopLoading();
      try {
        const c = await (await fetch('/cart.js')).json();
        if (before !== null && c.item_count === before) d.close();
      } catch (_) {}
    }, 7000);
  }, true);

  // El contenido del carrito se reemplaza al actualizar: volver a poner loader y brillo
  const obs = new MutationObserver(() => { ensureLoader(); addShine(); ensureStorageUpsell(); });
  const start = () => {
    const d = drawer();
    if (!d) return;
    ensureLoader();
    addShine();
    ensureStorageUpsell();
    obs.observe(d, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => { stopLoading(); requestAnimationFrame(() => { ensureLoader(); addShine(); ensureStorageUpsell(); }); });
      subscribe(PUB_SUB_EVENTS.cartError, () => { const dd = drawer(); stopLoading(); if (dd) dd.close(); });
    }
  };
  if (document.readyState === 'complete') start(); else document.addEventListener('DOMContentLoaded', start);

  // 2) Botón de pago: respuesta inmediata
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('#CartDrawer-Checkout');
    if (!btn || btn.disabled) return;
    btn.classList.add('titan-going');
    const label = btn.firstChild;
    if (label && label.nodeType === 3) label.textContent = 'Abriendo pago… ';
    setTimeout(() => btn.classList.remove('titan-going'), 6000);
  });

  // 3) Efecto 3D al mover el dedo o el mouse sobre cada producto
  if (!reduce) {
    document.addEventListener('pointermove', (e) => {
      const card = e.target.closest && e.target.closest('cart-drawer .cart-item');
      if (!card) return;
      const r = card.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      card.style.setProperty('--ry', (x * 10).toFixed(2) + 'deg');
      card.style.setProperty('--rx', (-y * 10).toFixed(2) + 'deg');
    }, { passive: true });
    document.addEventListener('pointerout', (e) => {
      const card = e.target.closest && e.target.closest('cart-drawer .cart-item');
      if (card && !card.contains(e.relatedTarget)) {
        card.style.removeProperty('--ry');
        card.style.removeProperty('--rx');
      }
    }, { passive: true });
  }
})();
